import React, { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import Navbar from './BasicComponents/Navbar';
import AppRoutes from './Routes/routes';
import { UserProvider } from './BasicComponents/UserContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SubscriptionProvider } from './Context/SubscriptionContext';
import { SidebarProvider } from './Context/SidebarContext';

import { setupAxiosInterceptors } from './utils/axiosInterceptor';
import ScrollToTop from './utils/ScrollToTop';
import './Styles/tenant-theme.css';

// Inner component to access navigate hook
const AppContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Setup axios interceptors with navigate function
    setupAxiosInterceptors(navigate);
  }, [navigate]);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <AppRoutes />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <UserProvider>
          <SubscriptionProvider>
            <SidebarProvider>
              <AppContent />
            </SidebarProvider>
          </SubscriptionProvider>
        </UserProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;



